export const CC_BRAND = "מוקד לב אחד";
export const CC_ORG = "לב אחד";

export type VolunteerTrack = "all" | "individual" | "group";

export const TRACK_PILLS: { value: VolunteerTrack; label: string }[] = [
  { value: "all", label: "הכל" },
  { value: "individual", label: "פרטני" },
  { value: "group", label: "קבוצה" },
];

export function trackSearchParam(track: VolunteerTrack): boolean | undefined {
  if (track === "all") return undefined;
  return track === "group";
}

export function trackLabel(isGroup: boolean): string {
  return isGroup ? "קבוצה" : "פרטני";
}

export function volunteerTrackLabel(track: VolunteerTrack): string {
  if (track === "individual") return "פרטני";
  if (track === "group") return "קבוצה";
  return "הכל";
}
